import Cookies from 'js-cookie';

/**
 * Authenticated fetch utility for API requests.
 * Automatically attaches JWT from cookies as Bearer token.
 * @param {string} url - The request URL.
 * @param {object} [options] - Fetch options.
 * @returns {Promise<Response>}
 */
export function authFetch(url, options = {}) {
  const token = Cookies.get('session_token');
  let headers = options.headers instanceof Headers
    ? Object.fromEntries(options.headers.entries())
    : { ...options.headers };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // NetworkError handling wrapper
  return fetch(url, { ...options, headers }).catch(e => {
    if (e instanceof TypeError) {
      // Custom error for network issues
      throw new Error('BACKEND_NETWORK_ERROR');
    }
    throw e;
  });
}
